import io from "socket.io-client";
require('dotenv').config();

let url = 'https://sofc.hmi.doosanfuelcell.cloud';

var userAgent = navigator.userAgent.toLowerCase();
if (userAgent.indexOf(' electron/') > -1) {
    url = 'http://localhost:4004';

    var fs =  window.require('fs');
    try {
        let json_data = JSON.parse(fs.readFileSync('customurl.json'));
        url = json_data.url;
    } catch(error) {
        console.log(error);
    }
}

export const socket = io(url, {transports: ['websocket', 'polling']});
